import React, {Component} from 'react';
import styles from './Ping.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

class Ping extends Component {
  pingRef = React.createRef();
  width = null;
  height = null;

  componentDidMount() {
    this.width = this.pingRef.current.offsetWidth;
    this.height = this.pingRef.current.offsetHeight;
  }

  render() {
    const width = this.width / 375;
    const nestX = Math.round((-147 * width) - (600/2));
    const nestY = Math.round((-21 * width) - (600/2));
    const googleX = Math.round((-74 * width) - (500/2));
    const googleY = Math.round((154 * width) - (500/2));
    const alexaX = Math.round((147 * width) - (500/2));
    const alexaY = Math.round((10  * width) - (500/2));

    return (
      <div
        className={cx('PingWrapper')}
        ref={this.pingRef}
      >
        <div className={cx('Ping', 'Ping__animation', 'Ping__nest', 'Ping__nest--one')} style={{top: (this.height / 2) + nestY, left: (this.width / 2) + nestX}}/>
        <div className={cx('Ping', 'Ping__animation', 'Ping__nest', 'Ping__nest--two')} style={{top: (this.height / 2) + nestY, left: (this.width / 2) + nestX}}/>
        <div className={cx('Ping', 'Ping__animation', 'Ping__google', 'Ping__google--one')} style={{top: (this.height / 2) + googleY, left: (this.width / 2) + googleX}}/>
        <div className={cx('Ping', 'Ping__animation', 'Ping__google', 'Ping__google--two')} style={{top: (this.height / 2) + googleY, left: (this.width / 2) + googleX}}/>
        <div className={cx('Ping', 'Ping__animation', 'Ping__alexa', 'Ping__alexa--one')} style={{top: (this.height / 2) + alexaY, left: (this.width / 2) + alexaX}}/>
        <div className={cx('Ping', 'Ping__animation', 'Ping__alexa', 'Ping__alexa--two')} style={{top: (this.height / 2) + alexaY, left: (this.width / 2) + alexaX}}/>
      </div>
    );
  }
};

export default Ping;


// WEBPACK FOOTER //
// ./src/app/intro/components/Ping/Ping.js